import axios from "axios";
import { RAPPI_PROVIDER } from "constants/rappi";
import fetchUtils from "utils/fetchUtils";

const getAllCertifications = async () => {
	try {
		const { data } = await fetchUtils.getCustom(`/b2b/invoicing/scape/invoicing-putters/show_certifications/${RAPPI_PROVIDER}`);
		return data.resource;
	} catch (error) {
		throw error;
	}
};

const postPartnerCertification = async (data: object) => {
	try {
		const resp = await fetchUtils.postCustom(`/crawling-extractions/certificate`, data);
		return resp;
	} catch (error) {
		throw error;
	}
};

const postUploadLayout = async (type: string, fileName: string, module_data: object, isAllies: boolean) => {
	try {
		let partner_id = module_data['partnerId']
		const resp: any = await fetchUtils.post(`/b2b/v2/b2b/layout?layout_type=${type}&filename=${fileName}&partnerId=${partner_id}&isAllies=${isAllies}`, {}, { token: true });
		return resp;
	} catch (error) {
		throw error;
	}
};

const putUploadLayout = async (url: string, body: string) => {
	try {
		const resp = await fetchUtils.putCsv(url, body, {contentType: 'text/plain'});
		return resp;
	} catch (error) {
		throw error;
	}
};

const getValidatedFile = async (business_event_id: number) => {
	try {
		const resp: any = await fetchUtils.get(`/b2b/v2/b2b/validation/${business_event_id}`, { token: true });
		return resp;
	} catch (error) {
		throw error;
	}
};

const postStarEmission = async (business_event_id: number, type: string) => {
	try {
		const resp = await fetchUtils.post(`/b2b/v2/b2b/emission/${business_event_id}?layout_type=${type}`, {}, { token: true });
		return resp;
	} catch (error) {
		throw error;
	}
}

const getStatusEmission = async (business_event_id: number) => {
	try {
		const resp: any = await fetchUtils.get(`/b2b/v2/b2b/emission/${business_event_id}`, { token: true });
		return resp;
	} catch (error) {
		throw error;
	}
}

const getDownloadReport = async (business_event_id: number) => {
	try {
		const resp = await fetchUtils.get(`/b2b/v2/b2b/report/${business_event_id}`, { token: true });
		return resp;
	} catch (error) {
		throw error;
	}
}

const getIssuancesInProgress = async (startDate: string, endDate: string, partnerId: number, search?: string) => {
	try {
		const resp = await fetchUtils.get(`/b2b/v2/b2b/emission/all-by-partner/${partnerId}?startDate=${startDate}&endDate=${endDate}${search ? `&search=${search}` : ''}`, { token: true });
		return resp;
	} catch (error) {
		throw error;
	}
}

export { getAllCertifications, postPartnerCertification, postUploadLayout, putUploadLayout, getValidatedFile, postStarEmission, getStatusEmission, getDownloadReport, getIssuancesInProgress};
